export default __webpack_public_path__ + "static/media/feature_megaways.88a2c8ba.jpg";